export enum Portal {
    CPP = 'cpp',
    SPP = 'spp',
    TEST_GEN = 'test_gen',
}

export function detectPortal(): Portal {
    const host = window.location.hostname;
    const url = window.location.href;
    const path = window.location.pathname;
    if (host.startsWith('supplier.') || url.includes('spp')) {
        return Portal.SPP;
    } else if (path.includes('admin_dash')) {
        return Portal.TEST_GEN;
    }
    return Portal.CPP;
}

export function isSupplierPortal(): boolean {
    return detectPortal() === Portal.SPP;
}
